import {
  httpsUrlRequired,
  requiredNumber,
  requiredText,
  urlText
} from '../genericSchemas';
import * as Yup from 'yup';

export const chatbotSchema = Yup.object().shape({
  name: requiredText,
  companyKey: requiredText,
  companyId: null,
  businessType: requiredText,
  businessSubType: null,
  webSiteUrl: Yup.array().of(urlText).min(1, 'Atleast one url must be added')
});

export const apiNodeSchema = Yup.object().shape({
  apiMethod: requiredText,
  apiUrl: requiredText,
  apiBodyTemplate: null,
  apiHeaders: null,
  queryParams: null,
  responseMapping: null,
  responseFact: null,
  successWhenContains: null,
  successWhenStatus: null,
  timeout: null,
  apiBodyType: null
});

export const bottemplatebusinessTypeSchema = Yup.object().shape({
  businessType: requiredText,
  businessSubType: null
});

export const addQuestionSchema = Yup.object().shape({
  categoryId: requiredNumber,
  question: requiredText,
  responseTypeId: requiredNumber,
  subQuestions: Yup.array().of(
    Yup.object().shape({
      question: requiredText,
      responseTypeId: requiredNumber
    })
  )
});
export const caseTypeQuestionSchema = Yup.object().shape({
  question: requiredText,
  subQuestions: Yup.array().of(
    Yup.object().shape({
      question: requiredText
    })
  )
});

export const extractVariableNodeSchema = Yup.object().shape({
  name: requiredText,
  description: Yup.string(),
  type: requiredNumber
});
